// @ts-ignore
export * from './components.d.ts';

export { generateTheme } from './utils/theme/generateTheme.js';
export type { Theme, BorderRadius, IconType } from './interface.js';
export { getPseudoRandomBackground } from './utils/prand.js';
